<template>
<div>
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="类型:">
            <el-input size="small" v-model="dataForm.typeCode" placeholder="类型" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="名称:">
            <el-input size="small" v-model="dataForm.typeName" placeholder="名称" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item class="fr">
            <el-button size="small" @click="getDataList()" icon="el-icon-search">
                查询
            </el-button>
<!--            <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                新建
            </el-button>-->
            <el-button size="small" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                新建
            </el-button>
            <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
        </el-form-item>
    </el-form>
    <div v-loading="dataListLoading">
        <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
            <el-table-column type="index" width="50" label="序号">
            </el-table-column>
            <el-table-column prop="typeCode" header-align="left" align="left" label="类型" width="250">
            </el-table-column>
            <el-table-column prop="typeName" header-align="left" align="left" label="名称">
            </el-table-column>
            <el-table-column prop="shortName" header-align="left" align="left" label="简化名称" width="200">
            </el-table-column>
            <el-table-column header-align="center" align="center" label="启用" width="80">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.enabled" :active-value="1" :inactive-value="0" @change="toggleEnabledHandle(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column header-align="center" align="left" width="140" label="操作">
                <template slot-scope="scope">
                    <!-- <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button> -->
                    <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                        修改
                    </el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>

    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
</div>
</template>

<script>
import {
    fetchPurchaseTypeList,
    deletePurchaseType,
    togglePurchaseTypeEnabled
    // list
} from '@/controller/systemData'
import AddOrUpdate from './purchase-type-add-or-update.vue'
export default {
    data() {
        return {
            dataForm: {
                typeCode: '',
                typeName: ''
            },
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            addOrUpdateVisible: false,
        }
    },
    components: {
        AddOrUpdate
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 280
            }
        }
    },
    activated() {
        this.getDataList()
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchPurchaseTypeList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'typeCode': this.dataForm.typeCode,
                'typeName': this.dataForm.typeName
            }).then(data => {
                if (data && data.code === '00') {
                    console.log(data)
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePurchaseType({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 切换启用状态
        toggleEnabledHandle(row) {
            togglePurchaseTypeEnabled({}, row.id).then(data => {
                if (data && data.code === '00') {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500
                    })
                    // 缓存已移除，无需重置
                } else {
                    this.$message.error(data.msg)
                    // 恢复原状态
                    row.enabled = row.enabled === 1 ? 0 : 1
                }
            }).catch(() => {
                row.enabled = row.enabled === 1 ? 0 : 1
            })
        },
    }
}
</script>
